import formatBibleReading from './formatBibleReading';

// Keep the order stable: the date hash selects a reference from this list.
export const DAILY_VERSES = [
  ['genesis', '創世記', 'Genesis', 1, 3],
  ['numbers', '民数記', 'Numbers', 6, 24],
  ['deuteronomy', '申命記', 'Deuteronomy', 6, 5],
  ['joshua', 'ヨシュア記', 'Joshua', 1, 9],
  ['proverbs', '箴言', 'Proverbs', 3, 5],
  ['isaiah', 'イザヤ書', 'Isaiah', 40, 31],
  ['matthew', 'マタイによる福音書', 'Matthew', 5, 9],
  ['matthew', 'マタイによる福音書', 'Matthew', 6, 33],
  ['matthew', 'マタイによる福音書', 'Matthew', 7, 7],
  ['matthew', 'マタイによる福音書', 'Matthew', 11, 28],
  ['mark', 'マルコによる福音書', 'Mark', 12, 31],
  ['luke', 'ルカによる福音書', 'Luke', 6, 31],
  ['john', 'ヨハネによる福音書', 'John', 3, 16],
  ['john', 'ヨハネによる福音書', 'John', 8, 12],
  ['john', 'ヨハネによる福音書', 'John', 14, 27],
  ['romans', 'ローマ人への手紙', 'Romans', 12, 12],
  ['romans', 'ローマ人への手紙', 'Romans', 12, 21],
  ['1corinthians', 'コリント人への第一の手紙', '1 Corinthians', 13, 13],
  ['2corinthians', 'コリント人への第二の手紙', '2 Corinthians', 5, 17],
  ['galatians', 'ガラテヤ人への手紙', 'Galatians', 6, 9],
  ['ephesians', 'エペソ人への手紙', 'Ephesians', 4, 32],
  ['philippians', 'ピリピ人への手紙', 'Philippians', 4, 4],
  ['philippians', 'ピリピ人への手紙', 'Philippians', 4, 13],
  ['1peter', 'ペテロの第一の手紙', '1 Peter', 5, 7],
];

export function dailyVerseDate(date = new Date()) {
  // ISO date in Japan, independent of the visitor's timezone.
  return new Date(date.getTime() + 9 * 60 * 60 * 1000).toISOString().slice(0, 10);
}

export function selectDailyVerse(dateKey) {
  let hash = 2166136261;
  for (const char of dateKey) hash = Math.imul(hash ^ char.charCodeAt(0), 16777619);
  return DAILY_VERSES[(hash >>> 0) % DAILY_VERSES.length];
}

export function extractDailyVerse(html, chapter, verse) {
  const doc = new DOMParser().parseFromString(formatBibleReading(html), 'text/html');
  const reference = `${chapter}:${verse}`;
  const marker = Array.from(doc.querySelectorAll('em, td.vn'))
    .find(node => node.textContent.trim() === reference);
  const source = marker?.matches('td')
    ? marker.closest('tr').querySelector('td.v')
    : marker?.closest('.bible-reading-verse');
  if (!source) throw new Error(`Missing verse: ${reference}`);
  source.querySelectorAll('em, rt, rp, script, style, button').forEach(node => node.remove());
  const text = source.textContent.replace(/\s+/g, ' ').trim();
  if (!text) throw new Error(`Empty verse: ${reference}`);
  return text;
}
